var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.149.328H.901c-.164 0-.247.271-.13.43L1.78 2.136c.289.394.756.394 1.045 0L3.835.758c.116-.159.033-.43-.13-.43h-.25a.492.492 0 00-.39.22l-.631.862c-.073.098-.189.098-.261 0L1.542.549a.498.498 0 00-.393-.221zM1.15 4.929H.9c-.163 0-.246-.272-.13-.43L1.78 3.12c.29-.394.756-.394 1.045 0l1.01 1.378c.116.158.033.43-.13.43h-.25a.492.492 0 01-.39-.221l-.631-.861c-.072-.099-.189-.099-.26 0l-.632.86a.498.498 0 01-.393.222z",
    fill: "#000"
  })));
}
export default __webpack_public_path__ + "static/media/up-down.8c9d8d58.svg";
export { SvgUpDown as ReactComponent };